<template>
  <div style="height:100%;">
    <el-row style="height:50%;">
      <el-col :span="24" style="height:100%;text-align:center;">
        <chart style="width:100%;height:100%;" :auto-resize="true" :options="options_dis"></chart>
      </el-col>
    </el-row>
    <el-row style="height:50%;position:relative;">
      <el-col :span="24" style="height:100%;">
        <chart style="width:100%;height:calc(100% - 30px);" :auto-resize="true" :options="options_all"></chart>
        <div style="height:30px;padding-left:30px;">
          选择统计时间段（按月）：
          <el-date-picker v-model="month" type="month" format="yyyy-MM" value-format="yyyy-MM" placeholder="选择月" size="mini"
            style="width:110px;" :clearable="false"></el-date-picker>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  export default {
    components: {},
    watch: {
      month() {
        // 统计时间段改变后 重新获取统计数据
        this.getTaskStat();
      }
    },
    data() {
      return {
        options_dis: {
          title: {
            text: "非法电台统计"
          },
          grid: {
            x: 40,
            y2: 30
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
              crossStyle: {
                color: "#999"
              }
            }
          },
          toolbox: {
            feature: {
              dataView: {
                show: true,
                readOnly: false
              },
              saveAsImage: {
                show: true
              }
            }
          },
          xAxis: [{
            name: "日",
            type: "category",
            data: [],
            axisPointer: {
              type: "shadow"
            }
          }],
          yAxis: [{
            type: "value",
            name: "个数",
            minInterval: 1
          }],
          series: [{
            name: "非法电台",
            type: "bar",
            data: [],
            label: {
              show: true,
              formatter: function (params) {
                if (params.value > 0) {
                  return params.value;
                } else {
                  return "";
                }
              },
              position: "top"
            },
            itemStyle: {
              normal: {
                // 随机显示
                color: function (params) {
                  return "#" + Math.floor(((params.value * 9301 + 49297) % 233280) / 233280.0 * 0xffffff).toString(
                    16);
                }
              }
            }
          }]
        },
        options_all: {
          title: {
            text: "非法电台监测上报次数统计"
          },
          grid: {
            x: 40,
            y2: 30
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
              crossStyle: {
                color: "#999"
              }
            }
          },
          toolbox: {
            feature: {
              dataView: {
                show: true,
                readOnly: false
              },
              saveAsImage: {
                show: true
              }
            }
          },
          xAxis: [{
            name: "日",
            type: "category",
            data: [],
            axisPointer: {
              type: "shadow"
            }
          }],
          yAxis: [{
            type: "value",
            name: "次数",
            minInterval: 1
          }],
          series: [{
            name: "非法电台上报次数",
            type: "bar",
            data: [],
            label: {
              show: true,
              formatter: function (params) {
                if (params.value > 0) {
                  return params.value;
                } else {
                  return "";
                }
              },
              position: "top"
            },
            itemStyle: {
              normal: {
                // 随机显示
                color: function (params) {
                  return "#" + Math.floor(((params.value * 9301 + 49297) % 233280) / 233280.0 * 0xffffff).toString(
                    16);
                }
              }
            }
          }]
        },
        // 月份（显示该月的任务统计，格式YYYY-MM）
        month: "0000-00"
      };
    },
    mounted() {
      // 设置任务显示月份为当前月
      let t = new Date();
      this.month = `${t.getFullYear()}-${t.getMonth() + 1}`;

      // 获取任务统计数据
      this.getTaskStat();
    },
    methods: {
      getTaskStat() {
        // 初始化数据，长度为设定月份的天数
        let yearMonth = this.month.split("-").map(x => Number(x));
        let t = new Date(yearMonth[0], yearMonth[1], 0);
        let maxDay = t.getDate(); // 该月的总天数
        let xAxisData = []; // 天数横坐标
        let radio_dis = []; // 非法电台统计
        let radio_all = []; // 非法电台上报次数统计
        for (let i = 0; i < maxDay; i++) {
          xAxisData[i] = i + 1;
          radio_dis[i] = 0;
          radio_all[i] = 0;
        }
        this.options_dis.xAxis[0].data = xAxisData;
        this.options_all.xAxis[0].data = xAxisData;

        // 获取非法电台统计数据
        this.$getJSON("/stat/illegal_radio_distinct", {
          yearMonth: this.month
        }).then(res => {
          for (let i = 0; i < res.data.length; i++) {
            let row = res.data[i];
            radio_dis[row["day"] - 1] = row["num"];
          }
          // 将数据设置到图表
          this.options_dis.series[0].data = radio_dis;

          // 更改标题中的时间
          this.options_dis.title.text =
            "非法电台统计（" +
            this.month.split("-")[0] +
            "年" +
            this.month.split("-")[1] +
            "月）";
        });

        // 获取非法电台上报次数统计数据
        this.$getJSON("/stat/illegal_radio_all", {
          yearMonth: this.month
        }).then(res => {
          for (let i = 0; i < res.data.length; i++) {
            let row = res.data[i];
            radio_all[row["day"] - 1] = row["num"];
          }
          // 将数据设置到图表
          this.options_all.series[0].data = radio_all;

          // 更改标题中的时间
          this.options_all.title.text =
            "非法电台监测上报次数统计（" +
            this.month.split("-")[0] +
            "年" +
            this.month.split("-")[1] +
            "月）";
        });
      }
    }
  };

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/RadioStat.vue